// @flow

import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'
import * as _ from 'lodash'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
    getAllUserInfoRequest: ['selectedRoleType', 'pageNumber', 'searchText', 'filters'],
    getAllUserInfoSuccess: ['all', 'pageNumber', 'pageSize'],
    getAllUserInfoError: ['error'],
    filterSchoolRequest: ['filters'],
    updateUserInfo: ['user']
})

export const AllUserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    error: undefined,
    fetching: false,
    pageNumber: 0,
    pageSize: 10,
    allUsersCount: 0,
    allUsers: [],
    searchText: undefined,
    filters: undefined,
    approvalStatus: undefined
})

/* ------------- Reducers ------------- */

export const allUserInfoRequest = (state: Object, request: Object) => {
    let {searchText = undefined, selectedRoleType = undefined, filters = undefined, reset = true} = request
    searchText = searchText && searchText.length && searchText.trim().length ? searchText : undefined
    const {allUsers} = state;
    return state.merge({
        fetching: true,
        allUsers: reset ? undefined : allUsers,
        error: undefined,
        searchText,
        filters,
        selectedRoleType
    })
}

export const updateUserInfo = (state: Object, {user}: Object) => {
    const {allUsers} = state
    const _allUsers = _.cloneDeep(allUsers)

    let find = _.find(_allUsers, (aUser) => {
        return aUser.id === user.id
    })

    if (find) {
        find.status = user.status
    }

    return state.merge({
        allUsers: [..._allUsers]
    })
}

export const allUserInfoSuccess = (state: Object, {all, pageNumber, pageSize}: Object) => {
    return state.merge({
        fetching: false,
        allUsers: all.users,
        pageNumber: pageNumber,
        pageSize: pageSize,
        allUsersCount: all.count,
        error: undefined
    })
}

export const allUserInfoError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    error
})

export const filterSchool = (state: Object, request: Object) => {
    let {filters = undefined} = request
    filters = filters && !isNaN(filters) ? filters : undefined
    return state.merge({
        searchText: undefined,
        filters
    })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_ALL_USER_INFO_REQUEST]: allUserInfoRequest,
    [Types.GET_ALL_USER_INFO_SUCCESS]: allUserInfoSuccess,
    [Types.GET_ALL_USER_INFO_ERROR]: allUserInfoError,
    [Types.UPDATE_USER_INFO]: updateUserInfo,
    [Types.FILTER_SCHOOL_REQUEST]: filterSchool
})
